export default __webpack_public_path__ + "static/media/icon_talk_regular_active.bd6563aa.svg";